import React, { useState } from 'react';
import { Calendar, ChevronFirst, ChevronLast, ChevronLeft, ChevronRight, Printer, Save, FileText, Grid3x3, Share } from 'lucide-react';
import styles from './EcobankChequeTemp.module.css';

export default function EcobankChequeTemp() {
  const [formData, setFormData] = useState({
    chequeNumber: '4981772420',
    day: '',
    month: '',
    year: '',
    payee: '',
    amountWordsLine1: '',
    amountWordsLine2: '',
    amountFigures: '',
    accountHolder: 'BROOKES SOFTWARE RESEARCH VENTURE',
    accountNumber: '2893002252',
    serialNumber: 'B0021'
  });

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className={styles.container}>
      <div className={styles.chequeWrapper}>
        {/* Ecobank Header */}
        <div className={styles.header}>
          <div className={styles.bankInfo}>
            <div className={styles.bankAddress}>302, HERBERT MACAULAY WAY, SABO YABA, LAGOS</div>
            <div className={styles.ecobankLogo}>
              <div className={styles.ecobankTitle}>ECOBANK</div>
              <div className={styles.ecobankSlogan}>The Pan African Bank</div>
            </div>
            <div>
              <div className={styles.chequeNumber}>{formData.chequeNumber}</div>
              {/* Date Section */}
              <div className={styles.dateSection}>
                <div className={styles.dateFields}>
                  <div className={styles.dateField}>
                    <label className={styles.dateLabel}>Day</label>
                    <input
                      type="text"
                      value={formData.day}
                      onChange={(e) => handleChange('day', e.target.value)}
                      className={styles.dateInput}
                      maxLength="2"
                    />
                  </div>
                  <div className={styles.dateField}>
                    <label className={styles.dateLabel}>Month</label>
                    <input
                      type="text"
                      value={formData.month}
                      onChange={(e) => handleChange('month', e.target.value)}
                      className={styles.dateInput}
                      maxLength="2"
                    />
                  </div>
                  <div className={styles.dateField}>
                    <label className={styles.dateLabel}>Year</label>
                    <input
                      type="text"
                      value={formData.year}
                      onChange={(e) => handleChange('year', e.target.value)}
                      className={styles.dateInput}
                      maxLength="4"
                    />
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>



        {/* Payee Section */}
        <div className={styles.payeeSection}>
          <div className={styles.payToLabel}>Pay to</div>
          <input
            type="text"
            value={formData.payee}
            onChange={(e) => handleChange('payee', e.target.value)}
            className={styles.payeeInput}
            placeholder="Enter payee name"
          />
        </div>

        {/* Amount in Words Section */}
        <div className={styles.amountWordsSection}>
          <div className={styles.sumLabel}>The sum of</div>
          <div className={styles.amountWordsContainer}>
            <input
              type="text"
              value={formData.amountWordsLine1}
              onChange={(e) => handleChange('amountWordsLine1', e.target.value)}
              className={styles.amountWordsInput}
              placeholder="Amount in words (first line)"
            />
            <input
              type="text"
              value={formData.amountWordsLine2}
              onChange={(e) => handleChange('amountWordsLine2', e.target.value)}
              className={styles.amountWordsInput}
              placeholder="Amount in words (second line)"
            />
            {/* <div className={styles.accountPayeeOnly}>A/C PAYEE ONLY</div> */}
          </div>
        </div>


        <div >


          {/* Amount in Figures */}
          <div className={styles.amountFiguresSection}>

            {/* Signature Section */}
            <div className={styles.signatureSection}>
              <div className={styles.authorizedSignature}>Authorized Signature(s)</div>
              <div className={styles.signatureLine}></div>
            </div>
            <div className={styles.amountFiguresSectionflex}>
              <div className={styles.ngnSymbol}>₦</div>
              <input
                type="text"
                value={formData.amountFigures}
                onChange={(e) => handleChange('amountFigures', e.target.value)}
                className={styles.amountFiguresInput}
                placeholder="0.00"
              />
            </div>

          </div>

        </div>

        {/* Account Holder Info */}
        <div className={styles.accountInfo}>
          <div>
            <div className={styles.accountHolder}>{formData.accountHolder}</div>
            <div className={styles.accountNumber}>{formData.accountNumber}</div>
          </div>
          {/* Serial Number */}
          <div className={styles.serialSection}>
            <div className={styles.serialNumber}>{formData.serialNumber}</div>
            <div className={styles.doNotWrite}>DO NOT WRITE SIGN OR STAMP BELOW THIS LINE</div>
          </div>

          {/* Security Features */}
          <div className={styles.securitySection}>
            <div className={styles.holographicSticker}></div>
            <div className={styles.stampDuty}>STAMP DUTY PAID</div>
            <div className={styles.blankStamp}></div>
          </div>
        </div>





        {/* MICR Line */}
        <div className={styles.micrLine}>
          <span className={styles.micrNumbers}>00000 2 20</span>
          <span className={styles.micrNumbers}>050150382</span>
          <span className={styles.micrNumbers}>2893002252</span>
          <span className={styles.micrNumbers}>02</span>
          <span className={styles.micrNumbers}>24032028</span>
          <span className={styles.micrNumbers}>15</span>
        </div>

        {/* Navigation Footer */}
        <div className={styles.footer}>
          <button className={styles.navBtn}>
            <ChevronFirst size={16} />
          </button>
          <button className={styles.navBtn}>
            <ChevronLeft size={16} />
          </button>
          <button className={styles.navBtn}>
            <ChevronRight size={16} />
          </button>
          <button className={styles.navBtn}>
            <ChevronLast size={16} />
          </button>
          <button className={styles.navBtn}>
            <FileText size={16} />
          </button>
          <button className={styles.navBtn} onClick={handlePrint}>
            <Printer size={16} />
          </button>
          <button className={styles.navBtn}>
            <Save size={16} />
          </button>
          <button className={`${styles.navBtn} ${styles.transferBtn}`}>
            Transfer Voucher
          </button>
          <button className={styles.navBtn}>
            <Share size={16} />
          </button>
          <button className={styles.navBtn}>
            <Grid3x3 size={16} />
          </button>
          <button className={`${styles.navBtn} ${styles.navBtnOrange}`} onClick={handlePrint}>
            <Printer size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}